export default __webpack_public_path__ + "static/media/RedHatDisplay-Regular.3f17d35f.ttf";